import { useGetMany, useRecordContext } from "ra-core";

import { Badge } from "@/components/ui/badge";

import type { Company, Tag } from "../types";

export const CompanyTagsList = ({ limit }: { limit?: number }) => {
  const record = useRecordContext<Company>();

  const ids = record?.tags ?? [];

  const { data: tags = [] } = useGetMany<Tag>(
    "tags",
    {
      ids,
    },
    {
      enabled: ids.length > 0,
    },
  );

  if (!record || tags.length === 0) {
    return null;
  }

  const visibleTags = typeof limit === "number" ? tags.slice(0, limit) : tags;

  const hiddenCount = tags.length - visibleTags.length;

  return (
    <div className="flex flex-wrap gap-1">
      {visibleTags.map((tag) => (
        <Badge
          key={tag.id}
          variant="secondary"
          className="font-normal rovero-colored-tag text-[#482719]"
          style={{
            backgroundColor: tag.color,
          }}
        >
          {tag.name}
        </Badge>
      ))}

      {hiddenCount > 0 && (
        <Badge variant="outline" className="font-normal">
          +{hiddenCount}
        </Badge>
      )}
    </div>
  );
};
